<app-grid
[columns]="columns"
[rows]="data.tableRows"
[tableParams]="data.tableParams"
[multiSelect]="false"
[gridName]="gridName"
[allowCopy]="false"
[allowDelete]="false"
[allowView]="false"
(refreshDataFromServer)="refreshData($event)"
(rowSelected)="rowSelectedEvent($event)"
(addClicked)="addQuestionBank()"
(editClicked)="editQuestionBank()">
</app-grid>